import NotificationsVideoPromotion from './NotificationsVideoPromotion'

export default NotificationsVideoPromotion
// eslint-disable-next-line import/export
export * from './NotificationsVideoPromotion'
